import { requst } from './config'

// 查询分页数据
export const getHomeListApi = params => {
    let url,
        query = ''
    const paramsList = Object.keys(params)
    paramsList.forEach(item => (query += `&${item}=${params[item]}`))
    const result = query.slice(1)
    url = window.encodeURI(`/setting/project/queryListByUserId?` + result)
    return requst.get(url)
}

// 新增项目
export const postHomeDataApi = params => {
    const url = `/setting/project`
    return requst.post(url, params)
}

/* 编辑项目 */
export const putHomeDataApi = params => {
    const url = `/setting/project`
    return requst.put(url, params)
}

/* 提交归档开关 */
export const putUpdateLockApi = params => {
    const url = `/setting/project/updateLock`
    return requst.put(url, params)
}

/* 删除 Home 表格数据 */
export const deletProjectApi = id => {
    const url = `/setting/project/${id}`
    return requst.delete(url)
}

/* 通过 id 获取项目 */
export const getProjectDataApi = id => {
    const url = `/setting/project/${id}`
    return requst.get(url)
}

// 字典数据树
export const getPMDictDataApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 获取帆软大屏登录链接
export const pomsLoginApi = () => {
    const url = `/fine/login`
    return requst.get(url)
}
